import React, { Fragment, Component } from 'react';
import { connect, batch } from 'react-redux';
import Store from '../../../../store/Store';
import './SurveyPage.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


// Component
import Section from '../../../components/Section/Section';
import SurveyItem from '../../../components/SurveyItem/SurveyItem';
import SurveyCompletePage from '../../../components/SurveyComplete/SurveyCompletePage';
import ReviewResponse from '../../../components/ReviewPage/ReviewResponse';
import { stringFormat, processItemResponse, redirectionUrl } from '../../../../utilities/processResponse';

// Action
import { scrollToQuestion, getQuestionList, putAllItemResponses, loadingSpinner, lostConnection, isAPIUpdate, putAllForMultiple } from '../../../../actions/SurveyAction';
import LostConnectionPage from '../../../components/LostConnectionPage/LostConnectionPage';

import SubmissionModal from '../../../components/SubmissionModal/SubmissionModal';
import LoadingIndicator from '../../../../utilities/LoadingIndicator';

class SurveyPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            openSecond: false,
            type: "review",
            totalQuestionCount: 0,
            totalPercentage: 0,
            isFinish: false,
            answered: false,
            unanswered: false,
            pageType: "finish",
            saveLater: false,
            pageInstrumentConfiguration: {},
            itemErrorMessage: false,
            itemResponses: {},
            timeout: null,
            submissionModal: false,
            connectionLost: false,
            isLoading: false,
            putAllResponse: null,
            finalAsSubmit: false,
            itemResponse: false,
            isPage: null,
            blockMovingForwardUntilRequiredItemsAnswered: false,
            itemResponseSets: {},
            counter: 0,
            showExitModal:false,
            lastPageNumber:0,
            isAllPagesItemResponses:false
        };
        this.itemErrorMessage = false;
        this.totalQuestionList = [];
        this.timer = null;
        this.redirectUrl = null;
        this.pageList = [];
        this.elapsedStartingTime = null;
        this.interval = null;
        this.itemCollection = [];
        this.blockMovingForwardUntilRequiredItemsAnswered = false;
        this.isUpdate = false;
        this.isRequiredItem = 0;
        this.isAnswerItem = 0;
        this.putAllTimeOut = null;
        this.secondChance = 0;
        this.isLostPageRender = true;
        this.finalAsSubmit = false;
        this.dependencies = [];
        this.emptyResponse = true;
        this.showBtn=false;
        this.statusTimOut=null;
    }

    static getDerivedStateFromProps = (props, state) => {
        const answeredQuestion = props.answeredQuestion;
        const putAllResponse = props.putAllResponse;

        if (state.totalPercentage !== answeredQuestion || props.itemResponseStatus || putAllResponse) {
            return {
                itemResponses: props.itemResponseStatus,
                totalPercentage: (answeredQuestion / state.totalQuestionCount) * 100,
                putAllResponse: putAllResponse,
                itemResponseSets: props.itemResponses
            }
        }
        return null;
    }

    componentDidMount() {
        const { dispatch, authorizationTokenGuid } = this.props;
        const getStore = Store.getState();
        var lastPageNumber = getStore.survey.surveyList !== undefined && getStore.survey.surveyList.pages !== undefined ? getStore.survey.surveyList.pages.length : 0;
        this.setState({lastPageNumber:lastPageNumber})
        const pageList = getStore.survey.surveyList.pages || [];
        const scales = getStore.survey.surveyList.scales || [];
        const pageInstrumentConfiguration = this.props.pageInstrumentConfiguration;
        const selectedAssessments = getStore.selectedAssessments.selectedAssessments || [];
        const { substitutions, dependencies, properties } = pageInstrumentConfiguration;

        localStorage.setItem("depCheckBoxVal","");

        if (substitutions && substitutions !== undefined) {
            substitutions.authorizationguid = authorizationTokenGuid;
        }

        properties.daisyChainOption = "1";

        this.pageList = pageList;

        var tempItems = [];
        var itemCount = 0;
        var pageCount = 0;

       this.pageList && this.pageList.filter((item, i) => {
        // if (!item.isSkipPageForMount) {
                let tempItemsList = item.items;

                // if (item.countPage === true) {
                //     pageCount = i + 1;
                // }
                pageCount = i + 1;
                if (item.blockMovingForwardUntilRequiredItemsAnswered) {
                    this.setState({ blockMovingForwardUntilRequiredItemsAnswered: item.blockMovingForwardUntilRequiredItemsAnswered });
                }
                tempItemsList.reduce((itemList, item) => {
                    if (item.reviewPageKey !== null) {
                        item.hasDepend = false;
                        item.activePageNumber = pageCount;
                        item.userResponse = [];
                        item.itemResponses = [];
                        item.ratees = selectedAssessments;
                        item.lowerLimit = 1;
                        item.upperLimit = 3;
                        item.isAnswer = false;
                        item.isHide = true;
                        item.isRequired = item.requiredIndicator === 2 ? true : false;
                        item.isRequiredLabel = item.isRequired;
                        item.isNA = false;
                        if (item.itemType === '2' || item.itemType === '102') {
                            var isMinSelection = scales[item.scaleKey].itemTypeProperties.hasOwnProperty("minSelections");

                            item.isRequired = isMinSelection == false || 0 ? false : item.requiredIndicator === 2 ? true : false;
                        }
                       
                        dependencies[item.key] !== undefined && dependencies[item.key].map((dep) => {
                            if (dep.key === item.key) {
                               
                                item.hasDepend = true;
                                this.pageList[i].checkOnNextButtonClick = true;
                                if(item.layoutHints == "samepage") {
                                    this.pageList[i].itemsOnSamePage = true;
                                } else {
                                    this.pageList[i].itemsOnSamePage = false;
                                }
                            }
                        });

                        tempItems = (itemList[item.reviewPageKey.toLowerCase()] || []);
                        tempItems.push(item);

                        this.totalQuestionList[item.reviewPageKey.toLowerCase()] = tempItems;
                        return this.totalQuestionList;

                    }
                }, {});
        });

        /** Item Count */
        for (const key in this.totalQuestionList) {
            if (this.totalQuestionList.hasOwnProperty(key)) {
                this.itemCollection.push(this.totalQuestionList[key][0]);
                itemCount++;
            }
        }

        this.setState({ totalQuestionCount: itemCount });

        this.interval = setTimeout(() => {
            this.handledEmptyResponse();
            clearTimeout(this.interval)
        }, 500);

        let intervalId;
        setTimeout(() => {
            intervalId = setInterval(() => {
                if (Object.keys(this.props.itemResponses).length !== 0 && !this.props.isLoader) {
                    this.setState({ isAllPagesItemResponses: true });
                    clearInterval(intervalId);
                }
            }, 500);
    
            setTimeout(() => {
                clearInterval(intervalId);
            }, 5000);
        }, 3000);

        /** Dispatch the group of items */
        batch(() => {
            dispatch(getQuestionList(this.totalQuestionList));
            dispatch(lostConnection(navigator.onLine));
            dispatch(loadingSpinner(true));
        });
    }

    componentDidUpdate() {

        const { itemResponseStatus, pageInstrumentConfiguration, putAllResponse, itemList, isPutAllUpdate, authorizationTokenGuid, assessmentInfosForDataCollection } = this.props;
        const { itemResponseSets } = itemResponseStatus;
        const { thankYouPage, substitutions } = pageInstrumentConfiguration;
        var iFrameDetection = (window === window.parent) ? false : true;
        const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        if (substitutions && substitutions !== undefined) {
            substitutions.authorizationguid = authorizationTokenGuid;
        }

        var isRequiredItem = 0;
        var isAnswerItem = 0;
        var isUnAnsweredItem = 0;

        if (isPutAllUpdate !== undefined && !isPutAllUpdate) {
            for (const key in itemResponseSets) {
                if (itemResponseSets.hasOwnProperty(key)) {
                    const element = itemResponseSets[key];
                    var spinnerElement = document.getElementsByClassName(`fa_${key}`)[0];

                    if (element.serverStatus === 200 || element.serverStatus === 400 || element.serverStatus === 404 || element.serverStatus === 500 || element.serverStatus === 418) {
                        if (spinnerElement !== undefined) {
                            spinnerElement.style = "margin-left: 42px;font-size: 25px;"
                            spinnerElement.style.display = "none";
                        }
                    } else {
                        if (spinnerElement !== undefined) {
                            spinnerElement.style = "margin-left: 42px;font-size: 25px;"
                            spinnerElement.style.display = "none";
                        }
                    }
                    if (element.serverStatus === 200 && thankYouPage.pageDisabled && putAllResponse !== null) {
                        this.redirectUrl = putAllResponse.redirectUrl;
                    }
                }
            }
        }

        for (const key in itemList) {
            if (itemList.hasOwnProperty(key)) {
                const element = itemList[key];
                for (const key in element) {
                    if (element.hasOwnProperty(key)) {
                        const tempArr = element[key];
                        if(pageInstrumentConfiguration.scales[tempArr.scaleKey].renderingHint !== 'captcha') {
                            if (pageInstrumentConfiguration.activeItemKey !== null) {
                                var scrollDiv = document.getElementById("ScrollDiv_" + pageInstrumentConfiguration.activeItemKey);
                    
                                if (scrollDiv && scrollDiv !== undefined && !iFrameDetection) {
                                    scrollDiv.scrollIntoView({ top: scrollDiv.offsetTop, behavior: "smooth" })
                                }
                            }
                    
                            if (!iFrameDetection) {
                              // document.body.scrollTop = 0;
                               // document.documentElement.scrollTop = 0;
                            }
                        }

                        if (tempArr.isRequired === true && tempArr.requiredIndicator === 2) {
                            isRequiredItem++;
                        }
                        if (tempArr.isAnswer === true) {
                            isAnswerItem++;
                        }
                        if (tempArr.isAnswer === false) {
                            isUnAnsweredItem++;
                        }
                        if (tempArr.isAnswer === false && tempArr.requiredIndicator === 1) {
                            this.secondChance++;
                        }
                    }
                }
            }
        }

        this.isRequiredItem = isRequiredItem;
        this.isAnswerItem = isAnswerItem;

        var submitButtonClasses = document.getElementsByClassName("_SummaryPageSubmitAsFinalButton")[0];

        if (submitButtonClasses) {
            if (this.state.totalQuestionCount === isAnswerItem) {
                submitButtonClasses.classList.add("_ButtonAllAnswered");
                submitButtonClasses.classList.remove("_PageNextButtonDisable");
                submitButtonClasses.classList.remove("_ButtonUnAnswered");

            } else if (isRequiredItem !== 0) {
                var isPresent = !!document.querySelector(`._SurveyPageLevel_${this.props.activePageKey} ._block`);
                if(!isPresent){
                    submitButtonClasses.classList.add("_ButtonAllAnswered");
                    submitButtonClasses.classList.remove("_PageNextButtonDisable");
                    submitButtonClasses.classList.remove("_PageNextButtonDisable");
                } else {
                    submitButtonClasses.classList.add("_PageNextButtonDisable");
                }
                    

            } else if (isUnAnsweredItem !== 0) {
                submitButtonClasses.classList.remove("_PageNextButtonDisable");
            } else {
                console.log("default")
            }
        }


        // if (pageInstrumentConfiguration.activeItemKey !== null) {
        //     //  debugger;
        //       console.log("hi");
        //       var scrollDiv = document.getElementById("ScrollDiv_" + pageInstrumentConfiguration.activeItemKey);
  
        //       if (scrollDiv && scrollDiv !== undefined && !iFrameDetection) {
        //           scrollDiv.scrollIntoView({ top: scrollDiv.offsetTop, behavior: "smooth" })
        //       }
        //   }
  
        //   if (!iFrameDetection) {
        //      document.body.scrollTop = 0;
        //      document.documentElement.scrollTop = 0;
        //   }
        

        if (this.emptyResponse) {
           this.handledEmptyResponse();
        } 
        if(ratees.length < 2) {
            this.handleRequiredButton();
        }
    }


    handleRequiredButton = () => {
        try {
            const { survey } = this.props;
            const pageInstrumentConfiguration = this.props.pageInstrumentConfiguration;
            const { dependencies } = pageInstrumentConfiguration;
            const nextButton = document.getElementsByClassName(`_buttonHideClass_${this.props.activePageKey}`)[0];

            for (const key in this.pageList) {
                if (this.pageList.hasOwnProperty(key)) {
                    const tempPageList = this.pageList[key];

                    if (tempPageList.key === this.props.activePageKey) {
                        
                        var tempPageItemList = tempPageList.items;
                        var count = 0;
                        for (const key in tempPageItemList) {
                            if (tempPageItemList.hasOwnProperty(key)) {
                                const element = tempPageItemList[key];
                                if (!element.isAnswer && element.isRequired && !element.hasDepend) {
                                    count++;
                                }
                               
                                if (!element.isAnswer && element.isRequired && element.hasDepend) {
                                   
                                    if(dependencies != undefined) {
                                        for( const depKey in dependencies) {
                                            dependencies[depKey].map((dep) => {
                                                if(element.hasDepend == true && element.layoutHints == 'samepage') {
                                                    var isPresent = !!document.querySelector(`._SurveyPageLevel_${this.props.activePageKey} .survey-item-block_${element.key}._block`);
                                                    if(isPresent){
                                                        count++;
                                                    }
                                                }
                                                if (!element.isAnswer && element.isRequired && element.hasDepend &&  element.layoutHints !== 'samepage') {
                                                    var isPresent = !!document.querySelector(`._SurveyPageLevel_${this.props.activePageKey} .survey-item-block_${element.key}._block`);
                                                    if(isPresent){
                                                        count++;
                                                    }
                                                }
                                               
                                            });
                                        }
                                    }
                                }
                                if (count === 0 && nextButton) {
                                    nextButton.disabled = false;
                                    nextButton.classList.remove("_PageNextButtonDisable");
                                } else {
                                    if(this.props.ratees.length > 1) {
                                        nextButton.disabled = true;
                                        nextButton.classList.add("_PageNextButtonDisable");
                                    }
                                    else {
                                        if(element.hasDepend) {
                                            var isPresent = !!document.querySelector(`._SurveyPageLevel_${this.props.activePageKey} ._block`);
                                            if(!isPresent && this.props.isLastPage && element.layoutHints !== 'samepage') {
                                                nextButton.disabled = false;
                                                nextButton.classList.remove("_PageNextButtonDisable");
                                            }
                                            if(isPresent && this.props.isLastPage && element.layoutHints !== 'samepage' ) {
                                                nextButton.disabled = true;
                                                nextButton.classList.add("_PageNextButtonDisable");
                                            }
                                            if(isPresent && !this.props.isLastPage && element.layoutHints !== 'samepage') {
                                                nextButton.disabled = true;
                                                nextButton.classList.add("_PageNextButtonDisable");
                                            }
                                            if(dependencies != undefined) {
                                                for( const depKey in dependencies) {
                                                    dependencies[depKey].map((dep) => {
                                                        if(element.hasDepend == true && element.layoutHints == 'samepage') {
                                                            var isPresent = !!document.querySelector(`._SurveyPageLevel_${this.props.activePageKey} .survey-item-block_${element.key}._block`);
                                                            if(element.key == dep.key && element.isAnswer == false && element.requiredIndicator == 2 && isPresent){
                                                                nextButton.disabled = true;
                                                                nextButton.classList.add("_PageNextButtonDisable");
                                                            }
                                                        }
                                                       
                                                    });
                                                }
                                            }
                                        } else {
                                            nextButton.disabled = true;
                                            nextButton.classList.add("_PageNextButtonDisable");
                                        }
                                    }
                                } 

                                if(this.showBtn == true) {
                                    // nextButton.disabled = false;
                                    // nextButton.classList.remove("_PageNextButtonDisable");
                                }

                                var tempPageItemResponseList = element.itemResponses[element.key];

                                if (tempPageItemResponseList) {
                                    for (const key in tempPageItemResponseList) {
                                        if (tempPageItemResponseList.hasOwnProperty(key)) {
                                            const tempPageItemResponseSet = tempPageItemResponseList[key];
                                            if ((tempPageItemResponseSet.responseValue !== null || tempPageItemResponseSet.openEnd !== null)) {
                                                tempPageList.blockMovingForwardUntilRequiredItemsAnswered = false;
                                                this.blockMovingForwardUntilRequiredItemsAnswered = false;
                                            } else {
                                                this.blockMovingForwardUntilRequiredItemsAnswered = true;
                                            }
                                        }
                                    }
                                } else {
                                }
                            }
                        }
                    } else {
                    }
                }
            }
        } catch (error) {
            console.log("Exceptions: while handling the required scenario:_", error.message)
        }
    }

    // Handle Dependency Question
    // handleDynamicDependency = (dependencies,checkboxAnswer,key,depKey,response) => {
    handleDynamicDependency = (checkboxAnswer,depKey,response, pageDep, reqInd) => {
        if(checkboxAnswer == true){
            localStorage.setItem('depCheckBoxVal',response);
           this.handleDependentItem(depKey, response, pageDep);
        } else {
            if(reqInd == 2){
                const nextButton = document.getElementsByClassName(`_buttonHideClass_${this.props.activePageKey}`)[0];
                this.showBtn = false;
                localStorage.setItem('depCheckBoxVal',null);
                nextButton.disabled = true;
                nextButton.classList.add("_PageNextButtonDisable");
            }
        }
    }

    // Handle Dependent Item
    handleDependentItem = (itemKey, response, pageDep) => {
        let depCheckBoxVal = localStorage.getItem('depCheckBoxVal');
        for (const key in this.pageList) {
            if (Object.hasOwnProperty.call(this.pageList, key)) {
                if (this.pageList[key].key == this.props.activePageKey) {
                    const tempItems = this.pageList[key].items;
                    for (const key in tempItems) {
                        if (Object.hasOwnProperty.call(tempItems, key)) {
                            const element = tempItems[key];
                            if(element.key == itemKey && element.isAnswer == true && response == depCheckBoxVal && element.requiredIndicator == 2) {
                                if(pageDep !== null && pageDep == "samePage") {
                                    this.showBtn = true;
                                } 
                            } 
                            
                            if(element.key == itemKey && element.isAnswer == false && response == depCheckBoxVal && element.requiredIndicator == 2) {
                                if(pageDep !== null && pageDep == "samePage") {
                                    this.showBtn = false;
                                } 
                            } 
                        }
                    }
                }
            }
        }
    }

    handledEmptyResponse = (item) => {
        try {
            const { itemResponses, pageInstrumentConfiguration, getAllItemResponseForMultiple, putAllForItemCollection, assessmentInfosForDataCollection, putAllForMultipleCollection, survey } = this.props;
            const { scales } = pageInstrumentConfiguration;
            const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

            for (const key in this.itemCollection) {

                if (this.itemCollection.hasOwnProperty(key)) {
                    const tempItems = this.itemCollection[key];
                    const scaleResponses = scales[tempItems.scaleKey];
                    const allScaleResponse = scaleResponses && scaleResponses !== undefined ? scaleResponses.scaleResponses : [];
                    const { isPracticeItem } = scaleResponses.itemTypeProperties;
                    var tempItemResponseArr = [];
                    var itemType = scaleResponses && scaleResponses !== undefined ? scaleResponses.itemType : tempItems.itemType;

                    tempItems.itemType = itemType;

                    if (tempItems.scaleKey !== null && isPracticeItem !== "1") {
                        for (let index = 0; index < allScaleResponse.length; index++) {
                            tempItemResponseArr.push({
                                'buttonGroup': null,
                                'isNa': false,
                                'itemType': tempItems.itemType,
                                'openEnd': null,
                                'response': allScaleResponse[index].response,
                                'responseValue': null,
                                'sequence': index + 1,
                            });

                            tempItems.itemResponses[tempItems.key] = tempItemResponseArr;
                            tempItems.userResponse = tempItemResponseArr;
                        }
                    }



                    for (const rKey in getAllItemResponseForMultiple) {
                        this.isUpdateResponse = true;
                        this.emptyResponse = false;

                        if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, rKey)) {
                            const elementRes = getAllItemResponseForMultiple[rKey];

                            for (const rateeKey in ratees) {
                                if (Object.hasOwnProperty.call(ratees, rateeKey)) {
                                    const rateesObj = ratees[rateeKey];
                                    var dataGuid = rateesObj.dataCollectionGuid;

                                    putAllForMultipleCollection[dataGuid] = {
                                        "dataCollectionGuid": dataGuid,
                                        "completionStatus": null,
                                        "itemResponseSetsTemp": [],
                                        "itemResponseSets": [],
                                    }

                                        var tempItemResponseObj = [{
                                            'buttonGroup': null,
                                            'isNa': false,
                                            'itemType': tempItems.itemType,
                                            'openEnd': null,
                                            'response': null,
                                            'responseValue': null,
                                            'sequence': 1,
                                        }];
                                        if (rKey === rateesObj.dataCollectionGuid) {
                                        const { itemResponseSets } = elementRes;

                                        if (itemResponseSets && itemResponseSets.length > 0) {
                                            for (const key in itemResponseSets) {

                                                if (itemResponseSets.hasOwnProperty(key)) {
                                                    const tempItemResponseSets = itemResponseSets[key];
                                                    var tempItemResponse = tempItems.itemType !== 5 ? tempItems.itemResponses[tempItems.key] : tempItems.userResponse;

                                                    if (tempItems.key === tempItemResponseSets.itemKey) {

                                                            for (const key in tempItemResponse) {
                                                                if (tempItemResponse.hasOwnProperty(key)) {
                                                                    const element = tempItemResponse[key];

                                                                    if (element.responseValue === null || element.openEnd === null) {
                                                                        tempItemResponseObj = tempItemResponseSets.itemResponses;
                                                                    } else {
                                                                        tempItemResponseObj = tempItemResponse;
                                                                    }
                                                                }
                                                            }

                                                            }

                                                    var sequence = 1;
                                                    for (const key in tempItemResponseObj) {
                                                        if (Object.hasOwnProperty.call(tempItemResponseObj, key)) {
                                                            const element = tempItemResponseObj[key];
                                                            element.sequence = sequence++;
                                                        }
                                                    }

                                                    if (tempItems.itemType !== null) {
                                                            var responseSet = itemResponses[tempItems.key] = {};
                                                        processItemResponse(tempItems.key, responseSet, tempItemResponseObj, tempItems.itemType, dataGuid, putAllForItemCollection,"onEmptyRes");
                                                    }
                                                }
                                            }
                                        } else {
                                            if (tempItems.itemType !== null) {
                                                    var tempItemResponseObj = [{
                                                        'buttonGroup': null,
                                                        'isNa': false,
                                                        'itemType': tempItems.itemType,
                                                        'openEnd': null,
                                                        'response': null,
                                                        'responseValue': null,
                                                        'sequence': 1,
                                                    }];
                                                    var responseSet = itemResponses[tempItems.key] = {};

                                                processItemResponse(tempItems.key, responseSet, tempItemResponseObj, tempItems.itemType, dataGuid, putAllForItemCollection,"onEmptyRes");

                                            }
                                        }
                                    }
                                }
                        	}
                        }
                    }
                }
            }
        } catch (error) {
            console.log("Exceptions: while unanswered and answered send to the PutAll:_", error.message)
        }
    }
    /**
     * Method to open modal
     *
     *  @param { type:String } type
     */
    onOpenModal = (type, flag) => {
        if (type === "answered") {
            this.setState({ answered: true });
        } else {
            this.setState({ answered: false });
        }

        if (type === "unanswered") {
            this.setState({ unAnswered: true });
        } else {
            this.setState({ unAnswered: false });
        }

        if (type === "exit") {
            this.setState({ open: false, openSecond: true, type: type });
        } else {
            this.setState({ open: true, openSecond: false, type: type });
        }
    }

    /**
     * Method to close modal
     *
     */
    onCloseModal = (type, page) => {
        if (type === "exit" || type === "review" || type === "Unanswered") {
            this.setState({ open: true, openSecond: false });
        } else {
            this.setState({ open: false, openSecond: false, isPage: page });
        }
    }

    /**
     * Method to redirect respective page
     *
     * @param { index:number } index
     * @param { type:string } type
     * @param { activePageNumber:number } activePageNumber
     *
     */
    pageRedirect = (index, type, activePageNumber) => {
        let questionIndex = index + 1;
        this.props.onNextButtonClick(questionIndex, type, activePageNumber);
    }

    /**
     * Method to scroll respective question
     *
     * @param { questionId:string }
     */
    scrollToDiv = (questionId) => {
        this.props.dispatch(scrollToQuestion(questionId));
    }

    renderProgressBar = (configuration) => {
        try {
            const { totalQuestionCount } = this.state;
            const { pageInstrumentConfiguration, currentActivePageCount, pageNumber, survey } = this.props;
            const { progressBarCssClass, progressBarOption, progressBarTextOverlay } = pageInstrumentConfiguration;
            var tempPageNumber = 0;

            if (this.isRequiredItem === 0) {
                this.itemErrorMessage = false;
            }

            for (const key in survey.pages) {
                if (Object.hasOwnProperty.call(survey.pages, key)) {
                    tempPageNumber++;
                }
            }

            var totalPercentageCount = progressBarOption !== 1 ?
                (this.isAnswerItem / totalQuestionCount) * 100 : (currentActivePageCount / tempPageNumber) * 100;

            return `<div class="${progressBarCssClass} row" style="display:${configuration.items && configuration.items.length > 0 ? "flex" : "block"}">
                            <div class="col-md-1"></div>
                                <div class="col-md-10">
                                    <div class="progress">
                                        <div
                                            role="progressbar"
                                            class="progress-bar progress-bar-animated progress-bar-striped" aria-valuenow="${totalPercentageCount.toFixed(0)}"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            style="width: ${totalPercentageCount.toFixed(0)}%;">
                                            <span class="show">
                                            ${progressBarOption !== 1 ? stringFormat(progressBarTextOverlay, this.isAnswerItem, totalQuestionCount): stringFormat(progressBarTextOverlay, this.isAnswerItem, totalPercentageCount.toFixed(0))}</span>
                                        </div>
                                    </div>
                                </div>
                            <div class="col-md-1"></div>
                        </div>`;
        } catch (error) {
            console.log("Exceptions: while updating progress bar_:" + error.message);
        }
    }

    handleFinishButton = () => {
        const { itemList, onFinishButtonClick, pageInstrumentConfiguration } = this.props;
        const { summaryPage } = pageInstrumentConfiguration;

        for (const key in itemList) {
            if (itemList.hasOwnProperty(key)) {
                const element = itemList[key];

                element.map((item, i) => {
                    if (item && item.isRequired === true) {
                        return false

                    } else {
                        if (!summaryPage.pageDisabled) {
                            onFinishButtonClick(true);
                        }
                        this.setState({ itemErrorMessage: false });
                        this.itemErrorMessage = false;
                    }
                })

            }
        }
        this.setState({ submissionModal: false })
    }

    saveLaterPageRedirect = (type) => {
        this.setState({ pageType: "saveLater", open: false, saveLater: true });
    }

    getResPonsesOnLoad = (itemKey, itemResponseSet, dataGuidId) => {
        const { activePageKey, assessmentInfosForDataCollection } = this.props;

        for (const key in this.pageList) {
            if (this.pageList.hasOwnProperty(key)) {
                const tempPageList = this.pageList[key];

                if (tempPageList.key == activePageKey) {
                    this.handleMultiUserRequiredNextButton(key, itemKey, itemResponseSet, dataGuidId, "preRes");
                }
            }
        }
      
    }

    /**
     * Added reusable method
     */
    setDynamicState = (nextButton, ratees, activePageKey, itemKey ) => {
        if(this.state[activePageKey+"_"+itemKey] !== undefined) {
            if(this.state[activePageKey+"_"+itemKey].length == ratees.length) {
                if(this.state[activePageKey+"_answeredRequiredItems"] === undefined) {
                    this.state[activePageKey+"_answeredRequiredItems"] = [];
                    this.state[activePageKey+"_answeredRequiredItems"].push({"key":activePageKey+"_"+itemKey});
                } else {
                    let foundInSelectedCheckBox = this.state[activePageKey+"_answeredRequiredItems"].some(el => el.key === activePageKey+"_"+itemKey);
                    if (!foundInSelectedCheckBox) {
                        this.state[activePageKey+"_answeredRequiredItems"].push({"key":activePageKey+"_"+itemKey});
                    }
                }
                
                if( this.state[activePageKey+"_requiredItems"] !== undefined && this.state[activePageKey+"_answeredRequiredItems"] !== undefined ){
                    if(this.state[activePageKey+"_requiredItems"].length == this.state[activePageKey+"_answeredRequiredItems"].length) {
                        nextButton.disabled = false;
                        nextButton.classList.remove("_PageNextButtonDisable");
                    } else {
                        nextButton.disabled = true;
                        nextButton.classList.add("_PageNextButtonDisable");
                    }
                } else {
                    nextButton.disabled = true;
                    nextButton.classList.add("_PageNextButtonDisable");
                }
            } else {
                if(this.state[activePageKey+"_"+itemKey].length != ratees.length) {
                    nextButton.disabled = true;
                    nextButton.classList.add("_PageNextButtonDisable");
                }
            }
        } else {
            nextButton.disabled = true;
            nextButton.classList.add("_PageNextButtonDisable");
        }
    }

     /**
     * Method to handle multiuser required item Next button
     *
     * @param { itemKey:String } itemKey
     * @param { itemResponseSet:Array } itemResponseSet
     * @param { type:String } type
     *
     */

    handleMultiUserRequiredNextButton = (pageKey, itemKey, itemResponseSet, dataGuidId, resType ) => {
        const { activePageKey, assessmentInfosForDataCollection } = this.props;
        const nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
        const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        const tempItems = this.pageList[pageKey].items;
        for (const key in tempItems) {
            if (Object.hasOwnProperty.call(tempItems, key)) {
                const pageElement = tempItems[key];
                if(pageElement.requiredIndicator == 2) {
                    if(this.state[activePageKey+"_requiredItems"] === undefined) {
                        this.state[activePageKey+"_requiredItems"] = [];
                        this.state[activePageKey+"_requiredItems"].push({"key":activePageKey+"_"+pageElement.key});
                    } else {
                    let foundInSelectedCheckBox = this.state[activePageKey+"_requiredItems"].some(el => el.key === activePageKey+"_"+pageElement.key);
                        if (!foundInSelectedCheckBox) {
                            this.state[activePageKey+"_requiredItems"].push({"key":activePageKey+"_"+pageElement.key});
                        }
                    }
                }
                if(pageElement.key == itemKey ) {
                    if(pageElement.requiredIndicator == 2) {
                        for (const ratee in ratees) {
                            
                            if( resType == "preRes" ? dataGuidId == ratees[ratee].dataCollectionGuid : itemResponseSet[itemKey].dataCollectionGuid == ratees[ratee].dataCollectionGuid ) {
                                if(resType == "preRes") {
                                    if(this.state[activePageKey+"_"+itemKey+"_"+"required"] === undefined) {
                                        this.setState({[activePageKey+"_"+itemKey+"_"+"required"]:true});
                                    }
                                }
                                if(itemResponseSet !== null) {
                                    var tempItemResponseObj =  resType == "preRes" ? itemResponseSet.itemResponses : itemResponseSet[itemKey].itemResponses;
                                    for (const key in tempItemResponseObj) {
                                        if (Object.hasOwnProperty.call(tempItemResponseObj, key)) {
                                            const element = tempItemResponseObj[key];
                                            if((element.itemType == "-1" || element.itemType == -1) || (element.itemType === "1" || element.itemType === 1) || (element.itemType === 4 || element.itemType === "4")) {
                                                if(element.openEnd !== null || element.response !== null ) {
                                                    if (this.state[activePageKey+"_"+itemKey] === undefined) {
                                                        this.state[activePageKey+"_"+itemKey] = [];
                                                        this.state[activePageKey+"_"+itemKey].push({"key":activePageKey+"_"+itemKey+"_"+ratees[ratee].key});
                                                    } else {

                                                        let foundInSelectedCheckBox = this.state[activePageKey+"_"+itemKey].some(el => el.key === activePageKey+"_"+itemKey+"_"+ratees[ratee].key);
                                                        if (!foundInSelectedCheckBox) {
                                                           
                                                            this.state[activePageKey+"_"+itemKey].push({"key":activePageKey+"_"+itemKey+"_"+ratees[ratee].key});
                                                        }
                                                    }
                                                } else {
                                                    if( (resType == "postRes" && (element.itemType == "-1" || element.itemType == -1)) || (resType == "postRes" && (element.itemType == "1" || element.itemType == 1))){
                                                        const index = this.state[activePageKey+"_"+itemKey].findIndex(item => (item.key === activePageKey+"_"+itemKey+"_"+ratees[ratee].key));
                                                        if(index > -1){
                                                            this.state[activePageKey+"_"+itemKey].splice(index, 1);
                                                        }
                                                        
                                                        const indexAnsArr = this.state[activePageKey+"_answeredRequiredItems"].findIndex(item => (item.key === activePageKey+"_"+itemKey));
                                                        if(indexAnsArr > -1){
                                                            this.state[activePageKey+"_answeredRequiredItems"].splice(indexAnsArr, 1);
                                                        }

                                                    } else {
                                                        nextButton.disabled = true;
                                                        nextButton.classList.add("_PageNextButtonDisable");
                                                    }
                                                }
                                                this.setDynamicState(nextButton, ratees, activePageKey, itemKey);
                                                
                                            }  
                                            else {
                                                // console.log("This item is not supported for multiuser");
                                            }
                                        }
                                    }
                                } else {
                                    this.handleRequiredButton();
                                }
                            }
                        }
                        
                    } else {
                        if( resType == "postRes"){ 
                            if(this.state[activePageKey+"_"+itemKey+"_"+"required"] !== undefined && this.state[activePageKey+"_"+"requiredItems"] !== undefined && this.state[activePageKey+"_"+"answeredRequiredItems"] !== undefined) {
                                if([activePageKey+"_"+itemKey+"_"+"required"] == true && ( this.state[activePageKey+"_requiredItems"].length == this.state[activePageKey+"_answeredRequiredItems"].length)) {
                                    nextButton.disabled = true;
                                    nextButton.classList.add("_PageNextButtonDisable");
                                } else {
                                    this.handleRequiredButton();
                                }
                            }
                        }  else {
                            if(this.state[activePageKey+"_"+itemKey+"_"+"required"] !== undefined) {
                                if(this.state[activePageKey+"_"+itemKey+"_"+"required"] == true) {
                                    nextButton.disabled = true;
                                    nextButton.classList.add("_PageNextButtonDisable");
                                } else {
                                    this.handleRequiredButton();
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * Method to handle multiple item response
     *
     * @param { itemKey:String } itemKey
     * @param { itemResponseSet:Array } itemResponseSet
     * @param { type:String } type
     *
     */
    handleItemResponse = (itemKey, itemResponseSet, type, dataGuidId) => {
        try {
            const { dispatch, dataCollectionGuid, activePageKey, elapsedTimeForPutAll, pageInstrumentConfiguration, putAllForItemCollection,  putAllForMultipleCollection, assessmentInfosForDataCollection } = this.props;
            const { updatePostingFrequencySeconds } = pageInstrumentConfiguration;
            const updatePostingFrequencySecondsTemp = updatePostingFrequencySeconds !== null ? updatePostingFrequencySeconds * 1000 : 4000;
            const dataCollectionGuidCol = dataGuidId !== undefined ? dataGuidId : dataCollectionGuid;
            const elapsedEndTime = new Date();
            const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
            var elapsedTime = elapsedEndTime - (this.elapsedStartingTime !== null ? this.elapsedStartingTime : elapsedTimeForPutAll);
            const selectionCount = this.props.itemResponses[itemKey].itemResponses.length;

            for (const key in this.pageList) {
                if (this.pageList.hasOwnProperty(key)) {
                    const tempPageList = this.pageList[key];

                    if (tempPageList.key === activePageKey) {
                        tempPageList.blockMovingForwardUntilRequiredItemsAnswered = selectionCount !== 0 ? false : true;
                        if(ratees.length > 1) {
                            this.handleMultiUserRequiredNextButton(key, itemKey, itemResponseSet, dataGuidId, "postRes");
                        }
                    }
                }
            }

            if(ratees.length < 2) {
                this.handleRequiredButton();
            }
            /* Updating the final putAll object */
            this.props.itemResponses[itemKey].itemResponses = itemResponseSet[itemKey].itemResponses;
            var sequence = 1;
            var tempItemResponseObj = this.props.itemResponses[itemKey].itemResponses;
          
            for (const key in tempItemResponseObj) {
                if (Object.hasOwnProperty.call(tempItemResponseObj, key)) {
                    const element = tempItemResponseObj[key];
                    element.sequence = sequence++;
                }
            }
            
            this.setState({ itemResponse: true, timeout: null });

            var completionStatus = null;

            if (type === "itemChange") {
                completionStatus = -1;
            } else {
                completionStatus = 1;
            }

            dispatch(lostConnection(navigator.onLine));
            var spinnerElement = null;
            this.isUpdate = true;
            clearTimeout(this.putAllTimeOut);
            dispatch(isAPIUpdate(true));

            if (Object.keys(putAllForMultipleCollection).length === 0) {
                this.handledEmptyResponse()
            }

            this.putAllTimeOut = setTimeout(() => {
                var count = 0;
                this.elapsedStartingTime = new Date();
                var elapsedTimeFinal = (elapsedTime / 1000) % 60;
                var elapsedTimeSeconds = elapsedTimeFinal.toFixed(2);

                const element = itemResponseSet[itemKey];

                if (element.itemKey === undefined) {
                    delete itemResponseSet[itemKey];
                }

                if (element.hasPosted === 0) {

                    if (type === "itemChange") {
                        spinnerElement = document.getElementsByClassName(`fa_${itemKey}`)[0];

                        if (spinnerElement !== undefined) {
                            spinnerElement.style = "margin-left: 42px;font-size: 25px;"
                            spinnerElement.style.display = "inline-block";
                        }
                    }
                    count++;

                    if (count === 1 && this.props.isPutAllUpdate) {
                        this.isUpdate = false;
                        clearTimeout(this.putAllTimeOut);
                        for (const key in putAllForMultipleCollection) {
                            if (Object.hasOwnProperty.call(putAllForMultipleCollection, key)) {
                                const putAllCollection = putAllForMultipleCollection[key];
                                
                                for (const itemCol in putAllForItemCollection) {
                                    if (Object.hasOwnProperty.call(putAllForItemCollection, itemCol)) {
                                        const element = putAllForItemCollection[itemCol];
                                        if (ratees.length > 1) {
                                           
                                            if (putAllCollection.dataCollectionGuid === element.dataCollectionGuid) {
                                                putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                            }
                                        } else {
                                            putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                        }

                                    }
                                }

                            }
                        }
                        
                        if (dataGuidId !== undefined) {
                            dispatch(putAllForMultiple(dataCollectionGuidCol, itemResponseSet, completionStatus, type, elapsedTimeSeconds, itemKey, putAllForMultipleCollection));
                        }
                    }
                }
            }, updatePostingFrequencySecondsTemp) //updatePostingFrequencySecondsTemp
        } catch (error) {
            console.log("Exception: While update the PutAll API call:_", error)
        }
    }


    handleFinalAsSubmitButton = (isRequiredItem, isAnswerItem, totalQuestionCount, testType) => {
        try {
            const { pageInstrumentConfiguration, dispatch, onFinishButtonClick, dataCollectionGuid, elapsedTimeForPutAll, putAllForMultipleCollection, putAllForItemCollection, assessmentInfosForDataCollection } = this.props;
            const { thankYouPage, redirections, substitutions, sections, closeParentOnSubmit } = pageInstrumentConfiguration;
            const { SubmitAsFinalRedirectionUrl } = redirections;
            const { timeout } = this.state;
            const unansweredRequired = sections.hasOwnProperty(pageInstrumentConfiguration.submissionModal.unansweredRequiredSectionKey) ? sections[pageInstrumentConfiguration.submissionModal.unansweredRequiredSectionKey].content : null;
            const unansweredUnrequired = sections.hasOwnProperty(pageInstrumentConfiguration.submissionModal.unansweredUnrequiredSectionKey) ? sections[pageInstrumentConfiguration.submissionModal.unansweredUnrequiredSectionKey].content : null;
            const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
            const elapsedEndTime = new Date();
            var elapsedTime = elapsedEndTime - (this.elapsedStartingTime !== null ? this.elapsedStartingTime : elapsedTimeForPutAll);
            const completionStatus = 1;
            const type = "submit";

            clearTimeout(timeout);
            if (isRequiredItem && isRequiredItem !== 0 && unansweredRequired !== null && !this.props.isLastPage ) {
                this.setState({ submissionModal: true, open: false });

            } else if (isAnswerItem && totalQuestionCount && isAnswerItem !== totalQuestionCount && unansweredUnrequired !== null && !this.props.isLastPage) {
                this.setState({ submissionModal: true, open: false });

            } else {
                this.closeSubmissionModal();
                var loadingTimer = null;
                if (thankYouPage.pageDisabled !== undefined && !thankYouPage.pageDisabled) {

                    loadingTimer = setInterval(() => {
                        if (Object.keys(this.props.itemResponses).length !== 0 && !this.props.isLoader) {
                            this.setState({ finalAsSubmit: navigator.onLine ? true : false, submissionModal: false, pageType: "thankYouPage", open: false });
                            this.finalAsSubmit = navigator.onLine ? true : false;

                            if (navigator.onLine) {
                                onFinishButtonClick(true);
                            }

                            if (this.state.isPage !== "reviewPage") {
                                this.handleFinishButton();
                            }
                            clearInterval(loadingTimer);
                        } else {
                            dispatch(loadingSpinner(false));
                        }
                    }, 0);
                } else {
                    loadingTimer = setInterval(() => {
                        var redirectUrl = `${SubmitAsFinalRedirectionUrl}`;
                     
                        if (!this.props.isLoader && navigator.onLine && redirectUrl !== "undefined") {
                            var urlRedirect = redirectionUrl(redirectUrl, substitutions);
                            if (urlRedirect && urlRedirect !== "undefined") {
                                window.location.href = urlRedirect;
                                clearInterval(loadingTimer);
                            } else {
                                clearInterval(loadingTimer);
                            }
                        }
                    }, 0);

                    this.setState({ isLoading: true });
                }

                if (Object.keys(this.props.itemResponses).length !== 0 && navigator.onLine) {
                    /* Updating the final putAll object */

                    this.elapsedStartingTime = new Date();
                    var elapsedTimeFinal = (elapsedTime / 1000) % 60;
                    var elapsedTimeSeconds = elapsedTimeFinal.toFixed(2);

                    for (const key in this.props.itemTempResponses) {
                        if (Object.hasOwnProperty.call(this.props.itemTempResponses, key)) {
                            const element = this.props.itemTempResponses[key];

                            if (element.itemKey !== undefined) {
                                const tempObj = this.props.itemResponses[element.itemKey];

                                if (element.itemResponses[0].itemType === "3" && element.itemKey === tempObj.itemKey) {
                                    tempObj.itemResponses = element.itemResponses;
                                }
                            }
                        }
                    }
                    if (Object.keys(putAllForMultipleCollection).length === 0) {
                        this.handledEmptyResponse()
                    }

                  
                    for (const key in putAllForMultipleCollection) {
                        if (Object.hasOwnProperty.call(putAllForMultipleCollection, key)) {
                            const putAllCollection = putAllForMultipleCollection[key];
                            
                            for (const itemCol in putAllForItemCollection) {
                                if (Object.hasOwnProperty.call(putAllForItemCollection, itemCol)) {
                                    const element = putAllForItemCollection[itemCol];

                                    if (ratees.length > 1) {
                                        if (putAllCollection.dataCollectionGuid === element.dataCollectionGuid) {
                                            putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                        }
                                    } else {
                                        putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                    }
                                    // if (putAllCollection.dataCollectionGuid === element.dataCollectionGuid) {
                                    // }
                                    //putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                }
                            }

                        }
                    }
                    dispatch(loadingSpinner(true));
                    if (Object.keys(putAllForItemCollection).length !== 0) {
                        localStorage.removeItem("depCheckBoxVal");
                        dispatch(putAllForMultiple(dataCollectionGuid, this.props.itemResponses, completionStatus, type, elapsedTimeSeconds, null, putAllForMultipleCollection));
                        
                        if(closeParentOnSubmit){
                            setTimeout(() => {
                                window.parent.postMessage("closeParent","*");
                            }, 1000);
                        }
                    } else {
                        // dispatch(putAllItemResponses(dataCollectionGuid, this.props.itemResponses, completionStatus, type, elapsedTimeSeconds));
                    }
                }
            }
          
        } catch (error) {
            console.log("Exception:while submitting the final survey:_", error.message)
        }
    }

    closeSubmissionModal = () => {
        this.props.dispatch(lostConnection(navigator.onLine));
        this.setState({ submissionModal: false, open: false });
    }

    handleSubmissionModal = () => {
        this.setState({ submissionModal: true });
    }

    handleNextPage = () => {
        const { onNextButtonClick, dispatch, activePageNumber, nextPageKey, ratees, isLastPage} = this.props;
        const pageInstrumentConfiguration = this.props.pageInstrumentConfiguration;
        // const {  dependencies } = pageInstrumentConfiguration;
        let nextPageKeyToNavigate = nextPageKey;
        var pagesNext = activePageNumber;
        var isPresent = !!document.querySelector(`._SurveyPageLevel_${nextPageKeyToNavigate} ._block`);
       
        this.pageList !== undefined && this.pageList.filter((page, key) => {
            if (page.checkOnNextButtonClick && nextPageKeyToNavigate !== null && page.key == nextPageKeyToNavigate && !this.props.isFirstPage && page.itemsOnSamePage !== true) {
                isPresent = !!document.querySelector(`._SurveyPageLevel_${nextPageKeyToNavigate} ._block`);
                    
                if (!isPresent) {
                    pagesNext = pagesNext + 1;
                    if(this.pageList[pagesNext] !== undefined && !isLastPage){
                        nextPageKeyToNavigate = this.pageList[pagesNext].key;
                    } else if(this.pageList[pagesNext] !== undefined && isLastPage){
                       isPresent = true;
                    } else{
                        pagesNext = pagesNext - 1;
                        isPresent = true;
                    }
                }
            }
        }); 

        var inputs = document.getElementsByTagName('video');
        if(inputs !== undefined) {
            for(var i = 1; i <= inputs.length; i++) {
                let videoId = document.getElementById('video'+i);
                //console.log("videoId",videoId);
                if(videoId !== null && videoId!== undefined) {
                videoId.pause();
                }
            }
        } 

        onNextButtonClick(null, null, pagesNext);
        if(ratees.length < 2) {
           this.handleRequiredButton();
        }

        dispatch(lostConnection(navigator.onLine));
    }

    handleBackButton = () => {
        const { activePageNumber, prevPageKey } = this.props;
        let prevPageKeyToNavigate = prevPageKey;
        var isPresent = !!document.querySelector(`._SurveyPageLevel_${prevPageKey} ._block`);
        var pagesBack = activePageNumber - 1;
        this.pageList !== undefined && this.pageList.filter((page) => {
                if (this.pageList[pagesBack - 1].checkOnNextButtonClick && this.pageList[pagesBack - 1].key === prevPageKeyToNavigate && this.pageList[pagesBack - 1].itemsOnSamePage !== true) {
                    isPresent = !!document.querySelector(`._SurveyPageLevel_${prevPageKeyToNavigate} ._block`);
                    if (!isPresent) {
                        pagesBack = pagesBack - 1;
                        prevPageKeyToNavigate = this.pageList[pagesBack - 1].key;
                    }
                }
        });

        this.setState({ submissionModal : false });
        this.props.onPreviousButtonClick(pagesBack);

    }

    renderConnectionLostModal = () => {
        try {
            const { connectionLost, isLastPage, isFinish } = this.props;

            return (!connectionLost ? <div>
                <LostConnectionPage
                    show={!connectionLost}
                    isLastPage={isLastPage}
                    onFinishButtonClick={() => this.props.onFinishButtonClick(isFinish)}
                    closeSubmissionModal={() => this.closeSubmissionModal()}
                /></div> : null);
        } catch (error) {
            console.log("Exceptions:while rendering the lost connection popup:_", error.message)
        }
    }

    renderExitModel = () => {
        const {pageInstrumentConfiguration} = this.props;
        const {
            pageExitOkButtonKey,
            pageExitCancelButtonKey,
            pageExitSectionKey,
            sections,
            buttons,
        } = pageInstrumentConfiguration;
        return <>
        <Modal show={this.state.showExitModal} onHide={() => this.setState({showExitModal:false})} animation={false}
            centered
        >
          
           <Modal.Body close> 
                { pageExitSectionKey !== null && sections.hasOwnProperty(pageExitSectionKey) && sections[pageExitSectionKey].content != null ?  
                <span 
                    className={`_PageExitSection ${sections[pageExitSectionKey].className}`}
                    dangerouslySetInnerHTML={{ __html: sections[pageExitSectionKey].content }}
                ></span> 
                :"Are you sure you want to close?"} 
            </Modal.Body>
           <Modal.Footer className='text-center'>
                { pageExitOkButtonKey !== null && buttons.hasOwnProperty(pageExitOkButtonKey) && buttons[pageExitOkButtonKey].buttonOption > 0 ?
                    <Button
                        type="button"
                        key={buttons[pageExitOkButtonKey].key}
                        onClick={() => this.handleExitOkButton()}
                        variant="primary"
                    >
                        { buttons[pageExitOkButtonKey].buttonText !== null  ? buttons[pageExitOkButtonKey].buttonText : "OK"} 
                    </Button> : null
                }
                { pageExitCancelButtonKey !== null && buttons.hasOwnProperty(pageExitCancelButtonKey) && buttons[pageExitOkButtonKey].buttonOption > 0 ?
                    <Button
                        type="button"
                        key={buttons[pageExitCancelButtonKey].key}
                        onClick={() => this.setState({showExitModal:false})} 
                        className='text-center' 
                        variant="secondary"
                    >
                        { buttons[pageExitCancelButtonKey].buttonText !== null  ? buttons[pageExitCancelButtonKey].buttonText : "Cancel"} 
                    </Button> : null
                }
          </Modal.Footer>
        </Modal>
      </>
    }

    handleExitOkButton = () => {
        try {
            const { redirections, substitutions } = this.props.pageInstrumentConfiguration;
            const { dispatch,dataCollectionGuid, elapsedTimeForPutAll, putAllForMultipleCollection, putAllForItemCollection, assessmentInfosForDataCollection } = this.props;
            const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
            const elapsedEndTime = new Date();
            var elapsedTime = elapsedEndTime - (this.elapsedStartingTime !== null ? this.elapsedStartingTime : elapsedTimeForPutAll);
            this.elapsedStartingTime = new Date();
            var elapsedTimeFinal = (elapsedTime / 1000) % 60;
            var elapsedTimeSeconds = elapsedTimeFinal.toFixed(2);
            
            const { SaveForLaterRedirectionUrl  } = redirections;
            this.setState({showExitModal:false})
            var redirectUrl = `${SaveForLaterRedirectionUrl}`;
            var surveyStatus = 0;
            var type =  "itemChange";
            

            if (Object.keys(this.props.itemResponses).length !== 0 && navigator.onLine) {
                /* Updating the final putAll object */
            
                this.elapsedStartingTime = new Date();
                var elapsedTimeFinal = (elapsedTime / 1000) % 60;
                var elapsedTimeSeconds = elapsedTimeFinal.toFixed(2);
            
                for (const key in this.props.itemTempResponses) {
                    if (Object.hasOwnProperty.call(this.props.itemTempResponses, key)) {
                        const element = this.props.itemTempResponses[key];
            
                        if (element.itemKey !== undefined) {
                            const tempObj = this.props.itemResponses[element.itemKey];
            
                            if (element.itemResponses[0].itemType === "3" && element.itemKey === tempObj.itemKey) {
                                tempObj.itemResponses = element.itemResponses;
                            }
                        }
                    }
                }
            
                if (Object.keys(putAllForMultipleCollection).length === 0) {
                    this.handledEmptyResponse()
                }
                this.setState({ isLoading: true });
                for (const key in putAllForMultipleCollection) {
                    if (Object.hasOwnProperty.call(putAllForMultipleCollection, key)) {
                        const putAllCollection = putAllForMultipleCollection[key];
            
                        for (const itemCol in putAllForItemCollection) {
                            if (Object.hasOwnProperty.call(putAllForItemCollection, itemCol)) {
                                const element = putAllForItemCollection[itemCol];
            
                                if (ratees.length > 1) {
                                    if (putAllCollection.dataCollectionGuid === element.dataCollectionGuid) {
                                        putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                    }
                                } else {
                                    putAllCollection.itemResponseSetsTemp[element.itemKey] = element;
                                }
                            }
                        }
            
                    }
                }
                if (navigator.onLine && redirectUrl !== "undefined" && redirectUrl !== null) {    
                    if (Object.keys(putAllForItemCollection).length !== 0) {
                        dispatch(loadingSpinner(true));
                        dispatch(putAllForMultiple(dataCollectionGuid, this.props.itemResponses, surveyStatus, type, elapsedTimeSeconds, null, putAllForMultipleCollection));
                        this.statusTimOut = setInterval(() => {
                            if(this.props.putAllStatus == 200) {
                                clearInterval(this.statusTimOut);
                                localStorage.removeItem("depCheckBoxVal");
                                var urlRedirect = redirectionUrl(redirectUrl, substitutions);
                                window.location.href = urlRedirect;
                            }
                        }, 1000);
                    } 
                } else {
                    this.setState({showExitModal:false});
                }
            } else {
                this.setState({showExitModal:false});
            }
        } catch (error) {

        }

    }

    handleExitButton = () => {
        this.setState({showExitModal:true})
    }

    componentWillUnmount() {
        clearInterval(this.putAllTimeOut);
    }

    ContextualExample = () => {
        try {
            const { totalQuestionCount, lastPageNumber } = this.state;
            const { pageInstrumentConfiguration, activePageNumber, survey, configuration } = this.props;
            const { progressBarCssClass, progressBarOption, progressBarTextOverlay } = pageInstrumentConfiguration;
            var tempPageNumber = 0;

            if (this.isRequiredItem === 0) {
                this.itemErrorMessage = false;
            }

            for (const key in survey.pages) {
                if (Object.hasOwnProperty.call(survey.pages, key)) {
                    tempPageNumber++;
                }
            }

            var totalPercentageCount = progressBarOption !== 1 ?  (this.isAnswerItem / totalQuestionCount) * 100 : (activePageNumber / tempPageNumber) * 100;
            
                return `<div class="${progressBarCssClass} row" style="display:${configuration.items && configuration.items.length > 0 ? "flex" : "block"}">
                                <div class="col-md-12">
                                    <div class="progress">
                                        <div
                                            role="progressbar"
                                            class="progress-bar progress-bar-animated progress-bar-striped" aria-valuenow="${totalPercentageCount.toFixed(0)}"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            style="width: ${totalPercentageCount.toFixed(0)}%;">
                                            <span class="show">
                                            ${progressBarOption !== 1 ? stringFormat(progressBarTextOverlay, this.isAnswerItem, totalQuestionCount, null, null, null, activePageNumber, lastPageNumber) : stringFormat(progressBarTextOverlay, this.isAnswerItem, totalPercentageCount.toFixed(0), null, null, null, activePageNumber, lastPageNumber)}</span>
                                        </div>
                                    </div>
                                </div>
                        </div>`;
        } catch (error) {
            console.log("Exceptions: while updating progress bar_:" + error.message);
        }
      }

    
    render() {
        
        const {
            configuration,
            isFirstPage,
            isLastPage,
            ratees,
            pageNumber,
            isActivePage,
            isFinish,
            pageInstrumentConfiguration,
            dataCollectionGuid,
            connectionLost,
            onNextButtonClick,
            currentActivePageCount,
            activePageKey,
            itemResponses,
            itemTempResponses,
            totalPageNumber,
            horizontalAlignment,
            survey,
            activePageNumber
        } = this.props;

        const { open, type, totalQuestionCount, openSecond, submissionModal, pageType, isLoading, finalAsSubmit, isAllPagesItemResponses } = this.state;
        const {
            sections,
            pageNextButtonKey,
            pageReviewButtonKey,
            pageFinishButtonKey,
            pageExitButtonKey,
            pageBackButtonKey,
            buttons,
            properties,
            reviewPage,
            submitAsFinalButtonKey,
            substitutions,
            summaryPage,
            dependencies,
            suppressSaveForLater,
            saveForLaterWorkButtonKey,
            redirections,
            suppressSubmitButton,
            progressBarCssClass, progressBarOption, progressBarTextOverlay
        } = pageInstrumentConfiguration;


        const { SaveForLaterRedirectionUrl  } = redirections; 

        var showExitButtonUrl = `${SaveForLaterRedirectionUrl}`;

        var itemTempKey = null;
        var renderPageType = (finalAsSubmit || this.finalAsSubmit) && Object.keys(itemResponses).length !== 0 ? connectionLost ? "thankYouPage" : null : pageType;

        var buttonClassKey = null;
        var count = 0;

        var progressBarEle = document.getElementsByClassName("ProgressBar");

        for (const key in progressBarEle) {
            
            if (progressBarEle.hasOwnProperty(key)) {
                const element = progressBarEle[key];
                for (const key in element.classList) {
                    if (element.classList[key] === 'ProgressBar') {
                        //let test = this.renderProgressBar(configuration);
                        //console.log("test",test)
                    }
                }
                if (element.className === 'ProgressBar') {
                    element.innerHTML = this.ContextualExample(configuration);
                }
            }
        }

        let alignmentFlag = pageInstrumentConfiguration.horizontalAlignment !== null ? pageInstrumentConfiguration.horizontalAlignment : horizontalAlignment !== null ? horizontalAlignment : null;
        

        return (
            <Fragment>
                {this.renderExitModel()}
                {this.renderConnectionLostModal(count + 1)}
                {/* Review and response */}
                {isLoading ? <LoadingIndicator active={this.props.isLoader} /> : null}

                {!submissionModal ?
                    <SubmissionModal
                        active={submissionModal}
                        secondChance={this.secondChance !== undefined ? this.secondChance : 0}
                        pageInstrumentConfiguration={pageInstrumentConfiguration}
                        isRequiredCount={this.isRequiredItem}
                        closeSubmissionModal={() => this.closeSubmissionModal()}
                        handleFinalAsSubmitButton={(e) => this.handleFinalAsSubmitButton(null, null, null, type)}
                    /> : null}
                <ReviewResponse
                    open={open}
                    currentActivePageCount={currentActivePageCount}
                    openSecond={openSecond}
                    type={type}
                    itemList={this.props.itemList}
                    itemResponses={this.props.itemResponses}
                    answered={this.state.answered}
                    unAnswered={this.state.unAnswered}
                    activePageNumber={this.props.isActivePage}
                    totalQuestionCount={totalQuestionCount}
                    pageInstrumentConfiguration={pageInstrumentConfiguration}
                    onCloseModal={(type, page) => this.onCloseModal(type, page)}
                    scrollToDiv={(questionId) => this.scrollToDiv(questionId)}
                    openSaveLaterPage={(type) => this.saveLaterPageRedirect(type)}
                    onBackToPage={() => this.props.onPreviousButtonClick()}
                    onNextButtonClick={(num, type, activePageNumber) => this.pageRedirect(num, type, activePageNumber)}
                    handleItemResponse={(itemKey, itemResponseSet, type) => this.handleItemResponse(itemKey, itemResponseSet, type)}
                    handleFinalAsSubmitButton={(e, testType) => this.handleFinalAsSubmitButton(null, null, null, testType)}
                />
                
                
                <Container className={`surveyPage-Content _SurveyPageLevel_${activePageKey}`} style={isActivePage ? null : { display: 'none' }}>
                    {/* Section */}
                    {!isFinish && configuration.pagePreSection !== null ?
                        <>
                            {!isFirstPage ?
                                pageBackButtonKey !== null && buttons.hasOwnProperty(pageBackButtonKey) && buttons[pageBackButtonKey].buttonOption !== 0 ?
                                    <Button
                                        key={buttons[pageBackButtonKey].key}
                                        className={`_PageBackButton ${buttons[pageBackButtonKey].buttonCssClass}`}
                                        size="lg"
                                        type="button"
                                        onClick={(event) => {
                                            this.handleBackButton()

                                        }}
                                    >
                                        <i className={buttons[pageBackButtonKey].buttonFontAwesome} aria-hidden="true"></i>
                                        <span>
                                            &nbsp;{buttons[pageBackButtonKey].buttonText}
                                        </span>
                                    </Button> : null : null}

                            {configuration.hasPageExitButton ?
                                pageExitButtonKey !== null && buttons.hasOwnProperty(pageExitButtonKey) && buttons[pageExitButtonKey].buttonOption !== 0 ?
                                    <Button
                                        type="button"
                                        key={buttons[pageExitButtonKey].key}
                                        className={`_PageExitButton ${buttons[pageExitButtonKey].buttonCssClass} _PageLevelExitButton`}

                                    >
                                        <i className={buttons[pageExitButtonKey].buttonFontAwesome} aria-hidden="true"></i>
                                    </Button> : null : null}
                            {pageReviewButtonKey !== null && !reviewPage.pageDisabled && configuration.hasPageReviewButton ?
                                <Button
                                    key={buttons[pageReviewButtonKey].key}
                                    className={`_PageReviewButton ${buttons[pageReviewButtonKey].buttonCssClass} _PageLevelResponseButton`}
                                    size="lg"
                                    type="button"
                                    onClick={() => {
                                        this.onOpenModal("review", false)
                                        onNextButtonClick(null, "reviewButton", currentActivePageCount);
                                    }}
                                >
                                    {buttons[pageReviewButtonKey].buttonText}
                                </Button> : null}
                                {suppressSaveForLater !== null && !suppressSaveForLater && showExitButtonUrl !== null ?
                               pageExitButtonKey !== null && buttons.hasOwnProperty(pageExitButtonKey) && buttons[pageExitButtonKey].buttonOption !== 0 ?
                               <Button
                                   type="button"
                                   key={buttons[pageExitButtonKey].key}
                                   className={`_PageExitButton ${buttons[pageExitButtonKey].buttonCssClass} _PageLevelExitButton`}
                                    onClick={() => this.handleExitButton()}
                               >
                                   <i className={buttons[pageExitButtonKey].buttonFontAwesome} aria-hidden="true"></i>
                                   {
                                            buttons[pageExitButtonKey].buttonOption === 5 ? 
                                            <span>
                                                &nbsp;{buttons[pageExitButtonKey].buttonText !== null  ? buttons[pageExitButtonKey].buttonText : "Exit"}
                                            </span>
                                            : null
                                        }
                               </Button> : null : null}

                            {configuration.pagePreSection !== null && sections.hasOwnProperty(configuration.pagePreSection) && sections[configuration.pagePreSection].content !== "" ?
                                <Row>
                                    <Col md={1}></Col>
                                    <Col md={10}>
                                        <Section
                                            key={sections[configuration.pagePreSection].key}
                                            type='pre'
                                            html={sections[configuration.pagePreSection].content}
                                            substitutions={substitutions}
                                            className={`_PagePreSection ${sections[configuration.pagePreSection].className}`}
                                            activePageNumber={activePageNumber}
                                            lastPageNumber={this.state.lastPageNumber}
                                        />
                                    </Col>
                                    <Col md={1}></Col>
                                </Row>
                                : null
                            }
                        </> : null}
                    {/* Survey */}
                    
                    {isFinish && navigator.onLine ?
                        <SurveyCompletePage
                            {...this.props}
                            pageType={renderPageType}
                            totalQuestionCount={totalQuestionCount}
                            questionItemList={this.totalQuestionList}
                            pageInstrumentConfiguration={pageInstrumentConfiguration}
                            openModal={(type) => this.onOpenModal(type, false)}
                            handleFinalAsSubmitButton={(e) => this.handleFinalAsSubmitButton(null, null, null, type)}
                        /> :
                        configuration.items.length > 0 && configuration.items.map((itemConfiguration, i) => {
                            const { scales } = pageInstrumentConfiguration;
                            const scaleResponses = scales[itemConfiguration.scaleKey];
                            var itemType = null;

                            if (scaleResponses && scaleResponses.hasOwnProperty('itemType')) {
                                itemType = scaleResponses.itemType;
                            } else {
                                itemType = null;
                            }
                            if (itemType === "5") {
                                buttonClassKey = scaleResponses.key;
                            }
                                return <SurveyItem
                                    key={itemConfiguration.key}
                                    configuration={itemConfiguration}
                                    pageInstrumentConfiguration={pageInstrumentConfiguration}
                                    ratees={ratees}
                                    survey={this.props.survey}
                                    pageNumber={pageNumber}
                                    currentActivePageCount={currentActivePageCount}
                                    pageConfiguration={configuration}
                                    activePageKey={activePageKey}
                                    nextPageKey={this.props.nextPageKey}
                                    pageList={this.pageList}
                                    questionItemList={this.totalQuestionList}
                                    itemResponses={itemResponses}
                                    itemTempResponses={itemTempResponses}
                                    dependencies={dependencies}
                                    dataCollectionGuid={dataCollectionGuid}
                                    putAllForItemCollection={this.props.putAllForItemCollection}
                                    isLastPage={pageNumber === totalPageNumber}
                                    handleRequired={() => this.handleRequiredButton()}
                                    handleDynamicDependency={(checkboxAnswer,depKey,response, pageDep, reqInd)=>this.handleDynamicDependency(checkboxAnswer,depKey,response, pageDep, reqInd)}
                                    handleDependentItem={(itemKey, response, pageDep)=>this.handleDependentItem(itemKey, response, pageDep)}
                                    itemCount={configuration.items}
                                    horizontalAlignment={alignmentFlag}
                                    onNextButtonClick={(num, type, activePageNumber) => this.pageRedirect(num, type, activePageNumber)}
                                    handleItemResponse={(itemKey, itemResponseSet, type, dataGuidId) => this.handleItemResponse(itemKey, itemResponseSet, type, dataGuidId)}
                                    getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
                                    openOreModal = {this.props.openOreModal}
                                /> 
                            
                        })
                        
                    }

                    <Row id={`ItemErrorMessage_${itemTempKey}`} className="ItemErrorMessage text-center">
                        {this.state.itemErrorMessage ?
                            <Col md="12">
                                {properties.instrumentPageRequiredMessage}
                            </Col>
                            : null}
                    </Row>
                    {/* Footer */}
                   
                    <Row className="surveyPage-footer">
                        
                        <Col xs={1}></Col>
                        <Col xs={10} className="_Buttons">
                            {
                                !isLastPage && this.state.isPage === null && pageNextButtonKey !== null && buttons.hasOwnProperty(pageNextButtonKey) && buttons[pageNextButtonKey].buttonOption !== 0 ?
                                    <><Button
                                        type="button"
                                        variant="primary"
                                        key={buttons[pageNextButtonKey].key}
                                        id={"_ButtonHide_" + buttonClassKey}
                                        className={`_PageNextButton ${buttons[pageNextButtonKey].buttonCssClass} _buttonHideClass_${this.props.activePageKey}`}
                                        onClick={this.handleNextPage}
                                        size="lg"> 
                                        {buttons[pageNextButtonKey].buttonText}
                                    </Button><br />
                                    </>
                                    : !isFinish ? <>
                                        {!reviewPage.pageDisabled ?
                                            pageFinishButtonKey !== null && buttons.hasOwnProperty(pageFinishButtonKey) && buttons[pageFinishButtonKey].buttonOption !== 0 ? <Button
                                                key={buttons[pageFinishButtonKey].key}
                                                type="button"
                                                id={"_ButtonHide_" + buttonClassKey}
                                                className={`_PageFinishButton ${buttons[pageFinishButtonKey].buttonCssClass} _buttonHideClass_${this.props.activePageKey}`}
                                                variant="primary"
                                                disabled={isAllPagesItemResponses && isFirstPage ? this.props.isLoader : ''}
                                            size="lg">
                                            {isAllPagesItemResponses && this.props.isLoader ? <i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} /> : null}
                                            {buttons[pageNextButtonKey].buttonText}
                                            </Button> : null
                                            :
                                            submitAsFinalButtonKey !== null && buttons.hasOwnProperty(submitAsFinalButtonKey) && buttons[submitAsFinalButtonKey].buttonOption !== 0 ?
                                             <Button
                                                    type="button"
                                                    key={buttons[submitAsFinalButtonKey].key}
                                                    id={"_ButtonHide_" + buttonClassKey}
                                                    className={suppressSubmitButton == false ? `_SummaryPageSubmitAsFinalButton ${buttons[submitAsFinalButtonKey].buttonCssClass || ""} _buttonHideClass_${this.props.activePageKey}` : `_PageNextButton ${buttons[pageNextButtonKey].buttonCssClass} _buttonHideClass_${this.props.activePageKey}`}
                                                    variant="primary"
                                                    onClick={(e) => this.handleFinalAsSubmitButton(this.isRequiredItem, this.isAnswerItem, totalQuestionCount, null)}
                                                    size="lg"
                                                >
                                                    {suppressSubmitButton == false ? buttons[submitAsFinalButtonKey].buttonText : buttons[pageNextButtonKey].buttonText}
                                                </Button> : null}
                                    </> : null
                            }
                        </Col>
                        <Col xs={1}></Col>
                    </Row>
                    <Row className="text-center">
                        <Col xs="1"></Col>
                        <Col xs="10">
                            {configuration.pagePostSection !== null && sections.hasOwnProperty(configuration.pagePostSection) && configuration.pagePostSection !== null && sections[configuration.pagePostSection].content !== "" ?
                                <Section
                                    type='post'
                                    key={sections[configuration.pagePostSection].key}
                                    html={sections[configuration.pagePostSection].content}
                                    substitutions={substitutions}
                                    className={`_PagePostSection ${sections[configuration.pagePostSection].className}`}
                                /> : null}
                        </Col>
                        <Col xs="1"></Col>
                    </Row>
                    
                </Container>
                
            </Fragment>
        )
    }
    
    
}

const mapStateToProps = (state) => ({
    answeredQuestion: state.survey.answeredQuestionCount,
    itemList: state.survey.itemList,
    itemResponseStatus: state.survey.itemResponseStatus,
    putAllStatus:state.survey.putAllStatus,
    isSpinner: state.survey.isSpinner,
    connectionLost: state.survey.connectionLost,
    putAllResponse: state.survey.putAllResponse,
    isLoader: state.survey.isLoader,
    assessmentInfoDataCollection: state.survey.assessmentInfoDataCollection,
    isPutAllUpdate: state.survey.isPutAllUpdate,
    getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple,
    assessmentInfosForDataCollection: state.survey.assessmentInfoDataCollectionData
});

export default connect(mapStateToProps)(SurveyPage);
